module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-text-field', {
    attrs: {
      "placeholder": "rechercher...",
      "prepend-icon": "search",
      "hide-details": "",
      "single-line": "",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "success"
    },
    on: {
      "click": _vm.openFilterDialog
    }
  }, [_vm._v("Filtrage")]), _vm._v(" "), _c('v-card-text', [_c('div', [_vm._v(_vm._s(_vm.filteredQuestions.length) + " questions")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        _vm.addQuestion()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _vm._l((_vm.filteredQuestions), function(question, index) {
    return [_c('v-list-tile', {
      key: question.id,
      class: {
        'red': question.id == _vm.selectedQuestionId, 'lighten-4': question.id == _vm.selectedQuestionId
      },
      attrs: {
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.selectQuestion(question.id)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "pink"
      }
    }, [_vm._v(_vm._s(_vm.typeIcon(question)))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(question.question))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "grey--text text--darken-4"
    }, [_vm._v("Niveau : " + _vm._s(_vm.level(question)))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.questionToDelete = _vm.clone(question);
          _vm.deleteDialog = true
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("delete")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.playQuestion(question)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("play_circle_filled")])], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.filteredQuestions.length) ? _c('v-divider', {
      key: question.id + '-'
    }) : _vm._e()]
  })], 2), _vm._v(" "), (_vm.filteredQuestions.length === 0) ? _c('v-card-text', {
    staticClass: "Aligner",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('v-icon', [_vm._v("not_interested")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Confirmer")]), _vm._v(" "), _c('v-card-text', [_vm._v("Supprimer " + _vm._s(_vm.questionToDelete.name) + " ?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false;
        _vm.deleteQuestion(_vm.questionToDelete)
      }
    }
  }, [_vm._v("Supprimer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "brown darken-2",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Annuler")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "800"
    },
    model: {
      value: (_vm.filterDialog),
      callback: function($$v) {
        _vm.filterDialog = $$v
      },
      expression: "filterDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2"
  }, [_vm._v("Filtrage")]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type",
      "multiple": "",
      "chips": "",
      "items": _vm.types,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.selectedTypes),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "selectedTypes", $$v)
      },
      expression: "editedFilter.selectedTypes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Niveau",
      "multiple": "",
      "chips": "",
      "items": _vm.levels,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.selectedLevels),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "selectedLevels", $$v)
      },
      expression: "editedFilter.selectedLevels"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Diabète : inclure",
      "multiple": "",
      "chips": "",
      "items": _vm.diabetes,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.includedDiabetes),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "includedDiabetes", $$v)
      },
      expression: "editedFilter.includedDiabetes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Diabète : exclure",
      "multiple": "",
      "chips": "",
      "items": _vm.diabetes,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.excludedDiabetes),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "excludedDiabetes", $$v)
      },
      expression: "editedFilter.excludedDiabetes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Hypercholestérolémie : inclure",
      "multiple": "",
      "chips": "",
      "items": _vm.cholesterols,
      "item-text": "short",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.includedCholesterols),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "includedCholesterols", $$v)
      },
      expression: "editedFilter.includedCholesterols"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Hypercholestérolémie : exclure",
      "multiple": "",
      "chips": "",
      "items": _vm.cholesterols,
      "item-text": "short",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.excludedCholesterols),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "excludedCholesterols", $$v)
      },
      expression: "editedFilter.excludedCholesterols"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Régime sans sel : inclure",
      "multiple": "",
      "chips": "",
      "items": _vm.sssels,
      "item-text": "short",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.includedSSsels),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "includedSSsels", $$v)
      },
      expression: "editedFilter.includedSSsels"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Régime sans sel : exclure",
      "multiple": "",
      "chips": "",
      "items": _vm.sssels,
      "item-text": "short",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.editedFilter.excludedSSsels),
      callback: function($$v) {
        _vm.$set(_vm.editedFilter, "excludedSSsels", $$v)
      },
      expression: "editedFilter.excludedSSsels"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.filterDialog = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dddddisabled": !_vm.dirty || !_vm.valid
    },
    nativeOn: {
      "click": function($event) {
        _vm.filterDialog = false;
        _vm.setFilter()
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "800"
    },
    model: {
      value: (_vm.playDialog),
      callback: function($$v) {
        _vm.playDialog = $$v
      },
      expression: "playDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "display-1"
  }, [_vm._v("\n               " + _vm._s(_vm.playTitle) + "    "), _c('span', {
    staticClass: "body-2"
  }, [_vm._v("(question à " + _vm._s(_vm.playPoints) + ")")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_vm._v("\n               " + _vm._s(_vm.questionToPlay.question) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, _vm._l((_vm.questionToPlayImages), function(image) {
    return _c('div', [(image.pict) ? _c('img', {
      attrs: {
        "src": '/static/media/' + image.pict,
        "width": "150"
      }
    }) : _vm._e()])
  })), _vm._v(" "), _vm._l((_vm.questionToPlayItems), function(item) {
    return _c('div', [_c('v-btn', {
      attrs: {
        "block": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.questionAnswered(item)
        }
      }
    }, [_vm._v(_vm._s(item.proposition))])], 1)
  })], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600"
    },
    model: {
      value: (_vm.answerDialog),
      callback: function($$v) {
        _vm.answerDialog = $$v
      },
      expression: "answerDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "display-1"
  }, [_vm._v("\n               " + _vm._s(_vm.answeredItem.success ? "Bonne réponse !" : "Mauvaise réponse !") + "\n            ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "subheading"
  }, [_vm._v("\n               " + _vm._s(_vm.answeredItem.answer) + "\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.answerDialog = false;
        _vm.playDialog = false
      }
    }
  }, [_vm._v("Fermer")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5756e50f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nutrikiosk/QCUList.vue
// module id = 1192
// module chunks = 1